// extracted by mini-css-extract-plugin
export default {"list":"styles_list__gCUqQ","item":"styles_item__+IwQv"};